import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61169e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile__wrapper_main md:!tw-max-h-[unset]" }
const _hoisted_2 = { class: "profile__wrapper password__wrapper" }
const _hoisted_3 = { class: "upload-wrapper profile_img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "personal__details__input" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Manage Password", -1))
const _hoisted_8 = { class: "form__wrapper" }
const _hoisted_9 = { class: "form_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "newPassword",
  class: ""
}, "New password", -1))
const _hoisted_11 = { class: "form_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "reEnterPass",
  class: ""
}, "Confirm Password", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($setup.userImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: $setup.userImage,
              width: "150",
              height: "150",
              alt: "userImage"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createBlock(_component_UserProfileLogo, { key: 1 }))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_form, {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
          class: "",
          ref: "ruleFormRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                    variant: "outlined",
                    class: "c-input rounded-full input_field password__input",
                    rounded: "",
                    outlined: "false",
                    modelValue: $setup.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event)),
                    rules: $setup.validation.password,
                    placeholder: "Enter password",
                    "append-inner-icon": 
                    $setup.isShowPassword ? 'mdi-eye' : 'mdi-eye-off'
                  ,
                    "onClick:appendInner": _cache[1] || (_cache[1] = () => ($setup.isShowPassword = !$setup.isShowPassword)),
                    type: $setup.isShowPassword ? 'text' : 'password'
                  }, null, 8, ["modelValue", "rules", "append-inner-icon", "type"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_v_text_field, {
                    "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                    density: "compact",
                    variant: "outlined",
                    class: "c-input rounded-full input_field password__input",
                    rounded: "",
                    outlined: "false",
                    modelValue: $setup.confirmPassword,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.confirmPassword) = $event)),
                    rules: $setup.validation.confirmPassword,
                    placeholder: "Re-enter password",
                    "append-inner-icon": 
                    $setup.isShowConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                  ,
                    "onClick:appendInner": _cache[3] || (_cache[3] = 
                    () => ($setup.isShowConfirmPassword = !$setup.isShowConfirmPassword)
                  ),
                    type: $setup.isShowConfirmPassword ? 'text' : 'password'
                  }, null, 8, ["modelValue", "rules", "append-inner-icon", "type"])
                ])
              ]),
              _createVNode(_component_v_btn, {
                class: "button button-orange",
                type: "submit",
                block: "",
                loading: $setup.loading,
                onClick: $setup.onClickSubmitButton
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Update password")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        }, 512)
      ])
    ])
  ]))
}